import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isAuthenticated, isAdmin } from '../store/action/auth';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={ props =>
      { 
        if (isAuthenticated()) {
            return <Component {...props} />        
        } else {

          if (arrayOfPaths.includes(props.location.pathname)) {
            return <Redirect to={{ pathname: '/', state: { from: props.location } }}/>
          } else {
            return <Component {...props} />
          }
        }
      }
    }
  />
);

export default PrivateRoute;

const arrayOfPaths = [
  "/overview",
  "/address",
  "/billing",
  "/catalog",
  "/tickets",
  "/form",
  "/integrations",
  "/overview",
  "/setting",
  "/analytics",
  "/api-production-form",
  "/postpaid-registration",
  "/invoices",
]